import { DigitalBankingInformation } from "@/types";
import { CoreFieldProps, fieldTypes, SectionHeader } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import "./ComplexFields.scss";

export interface DigitalBankingInformationComplexFieldValue {
  isAccountOpenerForm?: boolean;
  shouldShowDigitalBankingFields?: boolean;
  readOnly?: boolean;
  showHeader?: boolean;
  headerLabel?: string;
}

export interface DigitalBankingInformationComplexFieldProps
  extends fieldTypes.BaseFieldProps<DigitalBankingInformation> {
  complexFieldValue: DigitalBankingInformationComplexFieldValue;
}

export const DigitalBankingInformationComplexField: FC<
  DigitalBankingInformationComplexFieldProps
> = (props) => {
  const readOnly = props.complexFieldValue?.readOnly || props.readOnly;

  const isAccountOpenerForm = props.complexFieldValue?.isAccountOpenerForm;
  const shouldShowDigitalBankingFields = props.complexFieldValue?.shouldShowDigitalBankingFields;

  return (
    <section className="complex-field-container digital-banking-information">
      <SectionHeader
        label={props.complexFieldValue?.headerLabel || props.label}
        hidden={!props.complexFieldValue?.showHeader}
      />
      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.DIGITAL_BANKING_INFORMATION.HAS_DIGITAL_BANKING}
          complexFieldProps={{ disabled: readOnly || isAccountOpenerForm }}
        />

        {/* If hasDigitalBanking is true, show the following fields */}
        {shouldShowDigitalBankingFields && (
          <>
            <FieldComplexV2
              {...props}
              complexFieldKey={
                COMPLEX_FIELD_KEYS.DIGITAL_BANKING_INFORMATION.DIGITAL_BANKING_USERNAME
              }
              complexFieldProps={
                {
                  hidden: !props.value?.hasDigitalBanking,
                  disabled: readOnly,
                } as Partial<CoreFieldProps>
              }
            />
            <FieldComplexV2
              {...props}
              complexFieldKey={COMPLEX_FIELD_KEYS.DIGITAL_BANKING_INFORMATION.DIGITAL_BANKING_ROLE}
              complexFieldProps={{
                hidden: !props.value?.hasDigitalBanking,
                disabled: readOnly,
              }}
            />
            <FieldComplexV2
              {...props}
              complexFieldKey={
                COMPLEX_FIELD_KEYS.DIGITAL_BANKING_INFORMATION.DIGITAL_BANKING_EMAIL_ADDRESS
              }
              complexFieldProps={
                {
                  hidden: !props.value?.hasDigitalBanking,
                  disabled: readOnly,
                } as Partial<CoreFieldProps>
              }
            />
            <FieldComplexV2
              {...props}
              complexFieldKey={
                COMPLEX_FIELD_KEYS.DIGITAL_BANKING_INFORMATION.DIGITAL_BANKING_PHONE_NUMBER
              }
              complexFieldProps={{
                hidden: !props.value?.hasDigitalBanking,
                disabled: readOnly,
              }}
            />
          </>
        )}
      </div>
    </section>
  );
};
